import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { Modal as NextModal, Text, styled } from '@nextui-org/react';
//import Separator from '@/src/components/clean/Separator/Separator';
import style from './modal.module.scss';
import { IoMdClose } from 'react-icons/io';
import dynamic from 'next/dynamic';
const ButtonDynamic = dynamic(
  () => import('@/src/v2/components/Button/Button'),
  { ssr: false }
);
type Props = {
  isActionDisabled?: boolean;
  onConfirm?: () => void;
  onClose: () => void;
  isOpen: boolean;
  confirmLabel?: string;
  title: string;
  hasCloseButton?: boolean;
  hasOnlyCloseButton?: boolean;
  width?: string;
  loading?: boolean;
  confirmStyle?: 'primary' | 'danger' | 'primary-v2' | 'secondary-v2';
  hideHeader?: boolean;
  icon?: ReactNode;
  isRemoveModal?: boolean;
  hasConfirmButton2?: boolean;
  confirmLabel2?: string;
  footerClass?: string;
  onConfirm2?: () => void;
};

const StyledModal = styled(NextModal, {
  [`& svg`]: {
    color: 'white',
  },
});

const Modal: FC<PropsWithChildren<Props>> = ({
  onClose,
  onConfirm,
  children,
  isOpen,
  title,
  confirmLabel,
  isActionDisabled = false,
  hasCloseButton = false,
  hasOnlyCloseButton = false,
  width = '',
  loading = false,
  confirmStyle = 'primary-v2',
  hideHeader = false,
  icon,
  hasConfirmButton2 = false,
  confirmLabel2 = '',
  footerClass = style['modal-footer'],
  onConfirm2,
}) => {
  return (
    <StyledModal
      width={width}
      // closeButton={!hideHeader}
      aria-labelledby="modal-title"
      open={isOpen}
      onClose={onClose}
      style={{
        width: width || '500px',
        background: '#0B121D',
        border: '2px solid #232d3a',
      }}
    >
      {!hideHeader && (
        <NextModal.Header className={style['headerClass']}>
          <Text id="modal-title">{title}</Text>
          <IoMdClose onClick={onClose} className={style['modal__close']} />
        </NextModal.Header>
      )}
      {hasOnlyCloseButton && (
        <div className={style['modal__only_close']}>
          <IoMdClose onClick={onClose} className={style['moda_close']} />
        </div>
      )}
      {icon && (
        <div className={style['modal--with-icon']}>
          <div className={style['modal--with-icon__icon']}>{icon}</div>
          <div className={style['modal--with-icon__title']}>{title}</div>
        </div>
      )}
      <NextModal.Body
        className={hideHeader ? style['para'] : style['para-without-header']}
      >
        {children}
      </NextModal.Body>
      {(confirmLabel !== '' || confirmLabel2 !== '') && (
        <>
          <NextModal.Footer className={footerClass}>
            {(confirmLabel !== '' || confirmLabel2 !== '') && (
              <>
                {hasCloseButton && (
                  <ButtonDynamic
                    type="close-modal"
                    onClick={onClose}
                    label={'Cancel'}
                  />
                )}
                {hasConfirmButton2 && (
                  <ButtonDynamic
                    disabled={isActionDisabled}
                    type="primary-v2"
                    onClick={onConfirm2}
                    label={confirmLabel2}
                    loading={loading}
                    className={style['modal--extra_button']}
                  />
                )}
                <ButtonDynamic
                  disabled={isActionDisabled}
                  type={confirmStyle || 'primary-v2'}
                  onClick={onConfirm}
                  label={confirmLabel}
                  loading={loading}
                />
              </>
            )}
          </NextModal.Footer>
        </>
      )}
    </StyledModal>
  );
};

export default Modal;
